module.exports = __webpack_public_path__ + "website/img/diagrama04.9d076362.jpg";